import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, TemplateRef, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { Section } from '../../../editor-container/editor-model';
import { BannerRendererComponent, BlogListRendererComponent, CategoryRendererComponent, DynamicRendererComponent, GridRendererComponent, HeroImageRendererComponent, ProductRendererComponent, RendererDataInterFace, RowRendererComponent, SliderRendererComponent, TestimonialRendererComponent, StoreFeatureRendererComponent } from '@urbannex/storethemes';
import { BuilderHostDirective } from './builder-host.directive';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { SectionCellStepperComponent } from './section-cell-stepper/section-cell-stepper.component';
import { SectionBuilderStoreService } from './section-builder-store.service';
import { Subject, Subscription, map, takeUntil } from 'rxjs';

@Component({
  selector: 'kve-shared-section-builder',
  templateUrl: './shared-section-builder.component.html',
  styleUrls: ['./shared-section-builder.component.scss']
})
export class SharedSectionBuilderComponent implements OnChanges, OnDestroy {
  @Input() section: Section;
  rendererType: string;
  rendererComponent: DynamicRendererComponent;
  hasLoaded = false;
  edit = true;

  private destroy$ = new Subject<void>();

  updateContent$: Subscription;

  section$ = this.sectionBuilderStoreService.section$.pipe(
    takeUntil(this.destroy$),
    map(section => section));


  @ViewChild('previewHost', { read: TemplateRef }) previewHost: TemplateRef<any>;
  @ViewChild(BuilderHostDirective, { static: false }) kveBuilderHost!: BuilderHostDirective;
  @Output() updateSection = new EventEmitter<Section>();

  constructor(
    protected ref: NbDialogRef<SectionCellStepperComponent>,
    private dialogService: NbDialogService,
    private sectionBuilderStoreService: SectionBuilderStoreService) { }



  ngOnChanges(changes: SimpleChanges): void {
    if (changes["section"]) {
      console.log(this.section)
      this.rendererType = this.section.rendererType;
      this.rendererComponent = this.resolveRenderer(this.rendererType);
      if (this.rendererComponent != undefined) {
        console.log(this.rendererComponent);
        this.loadComponent(this.rendererComponent.component);
      }
    }
  }

  ngAfterViewInit(): void {
    if (this.rendererComponent != undefined) {
      setTimeout(() => {
        this.loadComponent(this.rendererComponent.component);
      }, 500)
    }
    this.section$.subscribe(section => {
      console.log(section);
      this.rendererType = section.rendererType;
      this.rendererComponent = this.resolveRenderer(this.rendererType);
    })

    /* this.updateContent$.pipe(takeUntil(this.destroy$)).subscribe((content) => {
      console.log(content);
      this.sectionBuilderStoreService.section$.subscribe(section => {
        try{
          this.rendererComponent.data = section;
          this.loadComponent(this.rendererComponent.component);
        }catch(e){
          console.error("Renderer componentis not defined")
        }

      })
    }) */
    // this.updateContent$ =
    /* this.sectionBuilderStoreService.selectedContent$.pipe(
      takeUntil(this.destroy$)).subscribe((content) => {
        console.log(content);
        this.sectionBuilderStoreService.section$.subscribe(section => {
          try {
            this.rendererComponent.data = section;
            this.loadComponent(this.rendererComponent.component);
          } catch (e) {
            console.error("Renderer componentis not defined")
          }

        })
      }); */
    /* this.sectionBuilderStoreService.editState$.subscribe(data => {
      if (data == "updated") {
        console.log(data)
        this.sectionBuilderStoreService.section$.subscribe(section => {
          try {
            this.rendererComponent.data = section;
            this.loadComponent(this.rendererComponent.component);
          } catch (e) {
            console.error("Renderer componentis not defined")
          }

        })
      } else {
        console.log("Editing:" + data);
      }

    }) */
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadComponent(currentComponent: any) {
    const viewContainerRef = this.kveBuilderHost?.viewContainerRef;
    if (viewContainerRef != undefined) {
      viewContainerRef.clear();
      const componentRef = viewContainerRef.createComponent(currentComponent);
      (<RendererDataInterFace>componentRef.instance).data = this.rendererComponent.data;
      componentRef.changeDetectorRef.detectChanges();
      componentRef.setInput("edit", this.edit);
      componentRef.setInput("data", this.section);
      (<RendererDataInterFace>componentRef.instance).editUpdate.subscribe(data => {
        console.log(data);
      })
      if (currentComponent instanceof BannerRendererComponent) {
        currentComponent.editUpdate.subscribe(data => console.log(data))
      }
      (<RendererDataInterFace>componentRef.instance).createUpdate.subscribe(data => {
        this.sectionBuilderStoreService.updateSelectedCell(data)
        console.log(data);
        let component: Type<any> = SectionCellStepperComponent;
        this.dialogService.open(component, {
          context: {
            cell: data,
            section: this.section
          }
        }).onClose.subscribe(() => {
          this.sectionBuilderStoreService.section$.subscribe(section => {
            console.log(section);
            this.updateSection.emit(section);
            (<RendererDataInterFace>componentRef.instance).updateSection(section)
            componentRef.changeDetectorRef.detectChanges();
            component = null;
          })
        })

        // console.log(data)
      })

    }

  }



  resolveRenderer(rendererType: string): DynamicRendererComponent {
    console.log(this.rendererType);
    let rendererComponent: DynamicRendererComponent;
    switch (this.rendererType) {
      case "grid":
      case "RendererType.GRID":
      case "GRID":
        rendererComponent = new DynamicRendererComponent(GridRendererComponent, this.section.sectionData);
        break;
      case "row":
      case "RendererType.ROW":
        rendererComponent = new DynamicRendererComponent(RowRendererComponent, this.section);
        break;
      case "RendererType.BANNER":
      case "BANNER":
      case "banner":
        rendererComponent = new DynamicRendererComponent(BannerRendererComponent, this.section.sectionData);
        break;
      case "bloglist":
        rendererComponent = new DynamicRendererComponent(BlogListRendererComponent, this.section.sectionData);
        break;
      case "product":
        rendererComponent = new DynamicRendererComponent(ProductRendererComponent, this.section.sectionData);
        break;
      case "slider":
        this.section.sectionData.isPreview = true;
        rendererComponent = new DynamicRendererComponent(SliderRendererComponent, this.section.sectionData);
        break
      case "hero-image":
      case "RendererType.HEROIMAGE":
        rendererComponent = new DynamicRendererComponent(HeroImageRendererComponent, this.section);
        break;
      case "store-features":
      case "RendererType.STOREFEATURES":
        rendererComponent = new DynamicRendererComponent(StoreFeatureRendererComponent, this.section);
        break;
      /* case "slider":
        this.section = new KwikstoreSection<Slider>();
        this.section.heading = this.sectionData.heading;
        this.section.sliderOptions = this.sectionData;
        this.rendererComponent = new DynamicRendererComponent(SliderRendererComponent);
        this.rendererComponent.data = this.section.sliderOptions;
        if(this.currentComponent != undefined){
          this.currentComponent = this.rendererComponent.component;
          this.loadComponent(this.currentComponent);
        }else{
          this.currentComponent = this.rendererComponent.component;
        }
        break; */
      /* case "newsletter-sign-up":
        this.section = new KwikstoreSection<NewsLetterSignUp>();
        this.section.heading = this.sectionData.heading;
        this.section.newsLetterOptions = this.sectionData;
        this.rendererComponent = new DynamicRendererComponent(NewsletterSignupRendererComponent);
        this.rendererComponent.data = this.section.newsLetterOptions;
        if(this.currentComponent != undefined){
          this.currentComponent = this.rendererComponent.component;
          this.loadComponent(this.currentComponent);
        }else{
          this.currentComponent = this.rendererComponent.component;
        }
        break;
      case "store-features":
        this.section = new KwikstoreSection<StoreFeatures>()
        this.section.heading = this.sectionData.heading;
        this.rendererComponent = new DynamicRendererComponent(StoreFeatureRendererComponent);
        this.rendererComponent.data = this.sectionData;
        if(this.currentComponent != undefined){
          this.currentComponent = this.rendererComponent.component;
          this.loadComponent(this.currentComponent);
        }else{
          this.currentComponent = this.rendererComponent.component;
        }
        break;
      case "rich-text":
        this.section = new KwikstoreSection<RichTextBlock>()
        this.section.heading = this.sectionData.heading;
        this.rendererComponent = new DynamicRendererComponent(RichTextRendererComponent);
        this.rendererComponent.data = this.sectionData;
        if(this.currentComponent != undefined){
          this.currentComponent = this.rendererComponent.component;
          this.loadComponent(this.currentComponent);
        }else{
          this.currentComponent = this.rendererComponent.component;
        }
        break */;
      case "RendererType.TESTIMONIALS":
      case "testimonials":
        rendererComponent = new DynamicRendererComponent(TestimonialRendererComponent, this.section.sectionData);
        break;
      case "category":
        rendererComponent = new DynamicRendererComponent(CategoryRendererComponent, this.section.sectionData)
        break;
      case "RendererType.BLOGLIST":
        rendererComponent = new DynamicRendererComponent(BlogListRendererComponent, this.section);
        break;
      default:
        break;
    }
    return rendererComponent;
  }

}
